exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home-newsletters .mat-dialog-title {\r\n    border-radius: 2px 2px 0 0;\r\n}\r\n#home-newsletters .panel {\r\n    margin-bottom: 10px !important;\r\n}\r\n#home-newsletters .panel .panel-body {\r\n    padding: 1.5rem !important;\r\n}\r\n#home-newsletters {\r\n    font-size: 16px;\r\n}\r\n#home-newsletters p {\r\n    margin: 0;\r\n}\r\n#home-newsletters p.note {\r\n    font-size: 14px;\r\n    background-color: rgba(0,0,0,0.04);\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/dashboard/newsletters.component.css
// module id = ../../../../../client/app/shared/dashboard/newsletters.component.css
// module chunks = main